import React from 'react';
import { getAppUrl } from '../utils/urlHelper';

const DEMO_AUDIO_URL = '/recordings/general-service-demo-v1.mp3';

export default function ListenPage() {
  return (
    <div className="min-h-screen min-h-[100dvh] w-full flex-1 shrink-0 text-white" style={{ backgroundColor: '#07070f' }}>
      <div className="relative isolate min-h-screen min-h-[100dvh] w-full overflow-hidden" style={{ backgroundColor: '#07070f' }}>

        {/* Purple ambient glow */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(139,92,246,0.14) 0%, transparent 70%)', filter: 'blur(80px)' }} />
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(192,132,252,0.07) 0%, transparent 70%)', filter: 'blur(60px)' }} />
        </div>

        {/* Global grid */}
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'linear-gradient(rgba(139,92,246,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.025) 1px, transparent 1px)', backgroundSize: '64px 64px' }} />

        <div className="relative z-10 max-w-4xl mx-auto px-4 py-16 md:py-24">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex items-center justify-center gap-3 mb-6">
              <img
                src="/screenshots/appymascot.png.png"
                alt="Appy"
                className="w-12 h-12 object-contain"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  e.currentTarget.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden w-12 h-12 rounded-full items-center justify-center text-white text-sm font-bold" style={{ background: 'linear-gradient(135deg, #8B5CF6, #C084FC)' }}>A</div>
              <span className="text-2xl font-extrabold text-white tracking-tight">Appify.AI</span>
            </div>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold mb-5" style={{ backgroundColor: 'rgba(139,92,246,0.12)', border: '0.5px solid rgba(139,92,246,0.25)', color: '#C084FC' }}>
              <span className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-pulse" />
              Live Voice AI Demo
            </div>

            <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-5">
              Hear how Appify handles<br className="hidden md:block" /> real business calls
            </h1>
            <p className="max-w-2xl mx-auto text-base md:text-lg leading-relaxed" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Listen to a short real-world sample conversation. Appify answers instantly,
              captures intent, and helps businesses convert missed calls into booked jobs.
            </p>
          </div>

          {/* Player Card */}
          <div className="rounded-2xl p-6 md:p-8" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '0.5px solid rgba(255,255,255,0.08)' }}>
            <h2 className="text-lg font-bold text-white mb-1">Listen to the sample call</h2>
            <p className="text-sm mb-6" style={{ color: 'rgba(255,255,255,0.45)' }}>
              A quick conversation demo to show call quality and flow.
            </p>

            <audio
              controls
              preload="metadata"
              className="w-full"
              src={DEMO_AUDIO_URL}
            >
              Your browser does not support the audio element.
            </audio>

            {/* Feature pills */}
            <ul className="mt-8 grid gap-3 md:grid-cols-3 text-sm">
              {[
                '24/7 call handling',
                'Save hours every week on repetitive calls',
                'Far lower cost than full-time call staff',
              ].map((text) => (
                <li key={text} className="rounded-xl px-4 py-3" style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '0.5px solid rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.65)' }}>
                  {text}
                </li>
              ))}
            </ul>

            <p className="mt-5 text-sm font-semibold" style={{ color: '#C084FC' }}>
              Most businesses save 60–80% vs employing full-time phone support.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={getAppUrl('/register?plan=free')}
                className="w-full sm:w-auto text-center px-7 py-3 rounded-xl text-sm font-semibold text-white transition hover:opacity-90"
                style={{ background: 'linear-gradient(135deg, #8B5CF6, #C084FC)' }}
              >
                Build your own agent — free
              </a>
              <a
                href="/#contact"
                className="w-full sm:w-auto text-center px-7 py-3 rounded-xl text-sm font-semibold transition"
                style={{ backgroundColor: 'rgba(255,255,255,0.05)', border: '0.5px solid rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.8)' }}
              >
                Book a Demo Call
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
